import React, { useState } from "react";
import { Box, IconButton, useTheme, InputBase, Paper, MenuItem, List } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { useNavigate } from "react-router-dom";
import SideBarItems from "./SideBarItems";
import { UserSettingsMenu } from "../global";
import { NotificationBar } from "../global";

const Topbar = () => {
    const theme = useTheme();
    const navigate = useNavigate();
    const [searchTerm, setSearchTerm] = useState("");
    const [showDropdown, setShowDropdown] = useState(false);

    const searchMenuItems = (items, term) => {
        const normalizedTerm = term
            .toLowerCase()
            .normalize("NFD")
            .replace(/[\u0300-\u036f]/g, "");

        return items.flatMap((item) => {
            if (item.submenuItems) {
                return searchMenuItems(item.submenuItems, term);
            }

            const normalizedTitle = item.title
                .toLowerCase()
                .normalize("NFD")
                .replace(/[\u0300-\u036f]/g, "");

            return normalizedTitle.includes(normalizedTerm) ? [item] : [];
        });
    };

    const filteredItems = searchMenuItems(SideBarItems, searchTerm);

    const handleSearchChange = (e) => {
        const value = e.target.value;
        setSearchTerm(value);
        setShowDropdown(value.trim() !== "");
    };

    const handleMenuItemClick = (route) => {
        navigate(route);
        setSearchTerm("");
        setShowDropdown(false);
    };

    return (
        <Box 
            display="flex" 
            justifyContent="space-between" 
            alignItems="center"
            sx={{ 
                p: { xs: 1.5, sm: 2 },
                backgroundColor: theme.palette.background.paper,
                borderBottom: `1px solid ${theme.palette.divider}`,
                boxShadow: theme.shadows[1],
                position: 'sticky',
                top: 0,
                zIndex: 100,
            }}
        >
            {/* Search Box */}
            <Box position="relative" sx={{ width: { xs: "100%", sm: "300px" }, maxWidth: "400px" }}>
                <Paper
                    component="form"
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        borderRadius: 2,
                        p: "4px 8px",
                        boxShadow: theme.shadows[2],
                        border: `1px solid ${theme.palette.divider}`,
                        transition: 'all 0.2s ease-in-out',
                        '&:hover': {
                            boxShadow: theme.shadows[4],
                        },
                    }}
                >
                    <InputBase
                        sx={{ 
                            ml: 1, 
                            flex: 1,
                            '& .MuiInputBase-input': {
                                fontSize: '0.95rem',
                            },
                        }}
                        placeholder="Αναζήτηση"
                        value={searchTerm}
                        onChange={handleSearchChange}
                        onBlur={() => setTimeout(() => setShowDropdown(false), 200)}
                        onFocus={() => setShowDropdown(searchTerm.trim() !== "")}
                    />
                    <IconButton 
                        sx={{ 
                            p: 0.5,
                            color: theme.palette.primary.main,
                            '&:hover': {
                                backgroundColor: theme.palette.action.hover,
                            },
                        }}
                    >
                        <SearchIcon fontSize="small" />
                    </IconButton>
                </Paper>

                {/* Dropdown Menu */}
                {showDropdown && (
                    <Paper
                        elevation={3}
                        sx={{
                            position: "absolute",
                            top: "100%",
                            left: 0,
                            width: "100%",
                            zIndex: 10,
                            maxHeight: "300px",
                            overflowY: "auto",
                            mt: 1,
                            borderRadius: 2,
                            boxShadow: theme.shadows[6],
                            border: `1px solid ${theme.palette.divider}`,
                            '&::-webkit-scrollbar': {
                                width: '6px',
                            },
                            '&::-webkit-scrollbar-track': {
                                background: 'transparent',
                            },
                            '&::-webkit-scrollbar-thumb': {
                                background: theme.palette.action.hover,
                                borderRadius: '3px',
                                '&:hover': {
                                    background: theme.palette.action.selected,
                                },
                            },
                        }}
                    >
                        <List>
                            {filteredItems.map((item, index) => (
                                <MenuItem
                                    key={index}
                                    onClick={() => handleMenuItemClick(item.to)}
                                    sx={{
                                        pl: 2,
                                        py: 1.5,
                                        whiteSpace: "normal",
                                        wordBreak: "break-word",
                                        display: "flex",
                                        alignItems: "center",
                                        gap: 1.5,
                                        borderRadius: 1,
                                        mx: 1,
                                        my: 0.5,
                                        transition: 'all 0.2s ease-in-out',
                                        '&:hover': {
                                            backgroundColor: theme.palette.action.hover,
                                        },
                                    }}
                                >
                                    {item.icon}
                                    {item.title}
                                </MenuItem>
                            ))}

                            {filteredItems.length === 0 && (
                                <MenuItem disabled>Κανένα αποτέλεσμα</MenuItem>
                            )}
                        </List>
                    </Paper>
                )}
            </Box>

            {/* Notification Bar and User Settings Menu */}
            <Box 
                display="flex" 
                alignItems="center"
                sx={{
                    display: { xs: 'none', sm: 'flex' },
                    gap: 1,
                }}
            >
                {/* <NotificationBar /> */}
                {/* <UserSettingsMenu /> */}
            </Box>
        </Box>
    );
};

export default Topbar;
